
import React from 'react';

import { Link } from 'react-router-dom';

function RegistryStatusDefinitions() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Registry Status Definitions</h1>

        <div className="space-y-12 text-gray-800">
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">Status Definitions</h2>
            <div className="space-y-4">
              <div className="border border-gray-200 p-6 rounded-sm">
                <div className="flex items-center gap-3 mb-2">
                  <span className="bg-blue-100 text-blue-800 font-mono font-bold px-3 py-1 text-sm rounded-sm">DECLARED</span>
                  <span className="text-[#2F80ED] text-xs uppercase font-bold tracking-wide">Active</span>
                </div>
                <p className="text-[#64748B]">The organization has formally attested to their alignment with AASC standards. This is a self-reported status.</p>
              </div>

              <div className="border border-gray-200 p-6 rounded-sm">
                <div className="flex items-center gap-3 mb-2">
                  <span className="bg-yellow-100 text-yellow-800 font-mono font-bold px-3 py-1 text-sm rounded-sm">CONDITIONALLY DECLARED</span>
                  <span className="text-yellow-700 text-xs uppercase font-bold tracking-wide">Active (Restricted)</span>
                </div>
                <p className="text-[#64748B]">The organization has minor documentation gaps pending remediation.</p>
              </div>

              <div className="border border-gray-200 p-6 rounded-sm">
                <div className="flex items-center gap-3 mb-2">
                  <span className="bg-red-100 text-red-800 font-mono font-bold px-3 py-1 text-sm rounded-sm">SUSPENDED</span>
                  <span className="text-red-700 text-xs uppercase font-bold tracking-wide">Inactive</span>
                </div>
                <p className="text-[#64748B]">Status is temporarily paused due to an active investigation into a complaint or failure to renew.</p>
              </div>

              <div className="border border-gray-200 p-6 rounded-sm">
                <div className="flex items-center gap-3 mb-2">
                  <span className="bg-gray-200 text-gray-800 font-mono font-bold px-3 py-1 text-sm rounded-sm">REVOKED</span>
                  <span className="text-gray-600 text-xs uppercase font-bold tracking-wide">Inactive (Permanent)</span>
                </div>
                <p className="text-[#64748B]">Declaration has been permanently withdrawn due to confirmed violation of standards or ethical misconduct.</p>
              </div>

              <div className="border border-gray-200 p-6 rounded-sm">
                <div className="flex items-center gap-3 mb-2">
                  <span className="bg-gray-100 text-gray-500 font-mono font-bold px-3 py-1 text-sm rounded-sm">EXPIRED</span>
                  <span className="text-gray-400 text-xs uppercase font-bold tracking-wide">Inactive</span>
                </div>
                <p className="text-[#64748B]">The annual declaration period has ended without renewal.</p>
              </div>
            </div>
          </section>

          <div className="pt-8 border-t border-gray-200">
             <Link to="/verify-credential" className="text-[#2F80ED] font-bold hover:underline">
               &larr; Verify a Credential
             </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default RegistryStatusDefinitions;
